// Add your custom JS here.

// "Verder lezen" toggle voor WYSIWYG-blokken met een <!--more--> tag.
// Progressive enhancement: pas inklappen zodra JS beschikbaar is.
function initReadMore() {
  var blocks = document.querySelectorAll('.wysiwyg.has-more');

  for (var i = 0; i < blocks.length; i++) {
    blocks[i].classList.add('is-collapsible');
  }
}

if (document.readyState !== 'loading') {
  initReadMore();
} else {
  document.addEventListener('DOMContentLoaded', initReadMore);
}

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('.read-more-toggle');

  if (!toggle) {
    return;
  }

  event.preventDefault();

  var wrapper = toggle.closest('.has-more');

  if (!wrapper) {
    return;
  }

  var expanded = wrapper.classList.toggle('is-expanded');
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

  var label = toggle.querySelector('.text');
  var moreLabel = toggle.getAttribute('data-more');
  var lessLabel = toggle.getAttribute('data-less');

  if (label && moreLabel && lessLabel) {
    label.textContent = expanded ? lessLabel : moreLabel;
  }
});